import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'fund-valuation-frequency',
  action: ActionType.READ,
};
const createPermission = {
  resource: 'fund-valuation-frequency',
  action: ActionType.CREATE,
};
const updatePermission = {
  resource: 'fund-valuation-frequency',
  action: ActionType.UPDATE,
};
const deletePermission = {
  resource: 'fund-valuation-frequency',
  action: ActionType.UPDATE,
};

export const FundValuationFrequency = {
  list: listPermission,
  create: createPermission,
  update: updatePermission,
  delete: deletePermission,
};
